"use strict";

const CustomLayer = function () {
  var init = function (mapId, map, mapLayers, layerSettings) {
    const displayInThisModule = _displayInThisModule(layerSettings);
    if (!displayInThisModule) return;

    _loadToggledListenerForCustomLayer(mapId, map, mapLayers, layerSettings);
  };

  var _displayInThisModule = function (layerSettings) {
    const thisModule = Tree.get("tool");
    if (layerSettings.modules.includes(thisModule) || layerSettings.modules.includes("all")) {
      return true;
    } else {
      return false;
    }
  };

  var getCustomLayerKey = function (layerSettings) {
    const camelCaseName = Misc.toCamelCase(layerSettings.layerName);
    return `${camelCaseName}CustomLayer`;
  };

  var _loadToggledListenerForCustomLayer = function (mapId, map, mapLayers, layerSettings) {
    const layerKey = getCustomLayerKey(layerSettings);
    MapFunctions.whenLayerToggled(layerKey, mapId, function (isEnabled) {
      var currentMapLayer = mapLayers[`${layerKey}`];
      if (isEnabled) {
        enableLayer(map, currentMapLayer, layerSettings, mapLayers, layerKey);
      } else {
        disableLayer(map, currentMapLayer, layerSettings, layerKey);
      }
    });
  };

  var enableLayer = async function (map, currentMapLayer, layerSettings, mapLayers, layerKey) {
    if (currentMapLayer) {
      map.removeLayer(currentMapLayer);
    }

    let customLayer = null;
    if (layerSettings.mapLayerType === "map_server") {
      customLayer = await getCustomMapServerLayer(layerSettings);
    } else {
      customLayer = await CustomLayerConfig.getCustomFeatureLayerByType(layerSettings);
    }

    mapLayers[layerKey] = customLayer;

    if (layerSettings.mapLayerType === "map_server") {
      if (!Tree.get("enabledCustomMapServerLayers").includes(layerKey)) {
        Tree.select("enabledCustomMapServerLayers").push(layerKey);
      }
      $(".leaflet-catchment-pane, .leaflet-overCatchment-pane").addClass("esri-dynamic-map-layer");
    }

    return customLayer.addTo(map);
  };

  var getCustomMapServerLayer = async function (layerSettings, options = {}) {
    const { baseUrl, sublayerId } = CustomLayerConfig.parseMapServerUrl(layerSettings.serviceUrl);

    const layerOptions = {
      url: baseUrl,
      f: "image",
    };

    if (sublayerId !== null) {
      layerOptions.layers = [sublayerId];
    }

    const token = await CustomLayerConfig.getCustomLayerTokenIfNeeded();
    if (token) {
      layerOptions.token = token;
    }

    return L.esri.dynamicMapLayer(Object.assign(layerOptions, options));
  };

  var disableLayer = function (map, currentMapLayer, layerSettings, layerKey) {
    if (currentMapLayer) {
      map.removeLayer(currentMapLayer);
    }

    if (layerSettings.mapLayerType === "map_server") {
      const enabledCustomMapServerLayers = Tree.get("enabledCustomMapServerLayers").filter(
        (enabledLayer) => enabledLayer !== layerKey,
      );
      Tree.set("enabledCustomMapServerLayers", enabledCustomMapServerLayers);

      if (
        !Tree.get("enabledEsriLayers")?.length &&
        !Tree.get("enabledGeoServerLayers")?.length &&
        !Tree.get("enabledCustomMapServerLayers")?.length
      ) {
        $(".leaflet-catchment-pane, .leaflet-overCatchment-pane").removeClass(
          "esri-dynamic-map-layer",
        );
      }
    }
  };

  var getCustomLayersToDisplayByModule = function (layerSettings) {
    const thisModule = Tree.get("tool");
    const moduleLayers = layerSettings?.layers.filter((layer) => {
      return layer.modules.includes(thisModule) || layer.modules.includes("all");
    });
    return moduleLayers;
  };

  var openCustomMapServerLayerPopup = function (map, feature, latlng) {
    const title = feature.layerName ? feature.layerName : feature.customLayerName;

    const rows = feature.popupParameters?.length
      ? feature.popupParameters.map((param) => ({
          label: param.label,
          displayValue: feature.properties[param.value],
        }))
      : null;

    const popupContent = nunjucks.render("popups/customMapServerLayerPopup.njk", {
      ...feature,
      title: title,
      rows: rows,
    });

    let popupOptions = MapFunctions.getPopupOptions();
    L.popup(popupOptions).setLatLng(latlng).setContent(popupContent).openOn(map);
  };

  return {
    init,
    getCustomLayerKey,
    getCustomLayersToDisplayByModule,
    openCustomMapServerLayerPopup,
  };
};

module.exports = CustomLayer();

const CustomLayerConfig = require("./customLayerConfig");
const MapFunctions = require("./mapFunctions");
const Misc = require("../misc");
const Tree = require("../tree");
